// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DisabledCountryContent_wrapper__1g5tu"};